/* @flow */

import { logError } from '../debug/debug';

export const SettledPromiseFulfilled = 'fulfilled';
export const SettledPromiseRejected = 'rejected';

export type AllSettledPromises<T> = Array<PromiseSettledResult<T>>;

// Used to ignore any promise return (success or failure) without any lint warning
const fireAndForget: (promise: Promise<any>, name: string) => void = (promise, name) => {
  promise
    .then(() => {
      /* Nothing to do */
    })
    .catch((error) => {
      /* Nothing to do */
      logError(`Error resolving background promise "${name}": ${error.message}`);
    });
};

// Wait a certain amount of time (in milliseconds) before resolving
const wait: (duration: number) => Promise<void> = (duration) =>
  new Promise((resolve) => {
    setTimeout(resolve, duration);
  });

export { fireAndForget, wait };
